import { sha256 } from 'js-sha256';
class UserService {
  get user() {
    return this.getUser();
  }

  getUser(token) {
    return new Promise(async (resolve, reject) => {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}api/v1/users`, {
        method: 'GET',
        headers: {
          token: token,
        },
      })
        .then((data) => resolve(data.json()))
        .catch((err) => reject(err));
    });
  }  
  
  getUserSetting({token}) {
    return new Promise(async (resolve, reject) => {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}api/v1/users/setting`, {
        method: 'GET',
        headers: {
          token: token,
        },
      })
        .then((data) => resolve(data.json()))
        .catch((err) => reject(err));
    });
  }

  login({ user_name, password, is_user_type }) {
    return new Promise(async (resolve, reject) => {
      const rawPassword = password;
      await fetch(`${process.env.REACT_APP_BACKEND_URL}api/v1/users/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_name,
          is_user_type,
          rawPassword,
          password: sha256(password),
        }),
      })
        .then((data) => resolve(data.json()))
        .catch((err) => reject(err));
    });
  }

  updateUser(token, id, data) {
    data.rawPassword = data.password;
    if (data.password) {
      data.password = sha256(data.password);
    }
    return new Promise(async (resolve, reject) => {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}api/v1/users/${id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          token: token,
        },
        body: JSON.stringify({ ...data }),
      })
        .then((data) => resolve(data.json()))
        .catch((err) => reject(err));
    });
  }

  createUser(token, data) {
    if (data.password) {
      data.password = sha256(data.password);
    }
    if (data.email) data.email = data.email += '@rtaf.mi.th';
    return new Promise(async (resolve, reject) => {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}api/v1/users`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          token: token,
        },
        body: JSON.stringify({ ...data }),
      })
        .then((data) => resolve(data.json()))
        .catch((err) => reject(err));
    });
  }

  deleteUser(token, id) {
    return new Promise(async (resolve, reject) => {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}api/v1/users/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          token: token,
        },
      })
        .then((data) => {
          console.log('data', data);
          resolve(data.json());
        })
        .catch((err) => reject(err));
    });
  }
}

export default UserService;
